<template>
	<div>
		<div class="titleIcon">
			<div class="inlin">
				<i :class="`iconfont ${icon} tableIcon`"></i>
				<span class="fz16">{{title}}</span>
			</div>
		</div>
		<div class="portraitLine disflex" ref="breadcrumb">
			<div v-if="reportList&&reportList.length>0" ref="nationwide">
				<div class="echarts">
					<div :id="echarts" class="barchartsHeight" ref="echarts"></div>
				</div>
			</div>
			<div v-else class="echartslineNull">
				<div class="icon">
					<svg-icon class="fz18 marr4" icon-class='icon-default-Nodata'></svg-icon>
				</div>
				<div class="text">暂无数据</div>
			</div>
		</div>
	</div>
</template>

<script>
	import echarts from 'echarts'
	export default {
		props: ['name', 'colorList', 'icon', 'title', 'reportList', 'chartsType','type'],
		data() {
			return {
				myChart: null,
				height: 25,
				barMaxWidth: 7,
				num: 0,
				data:[],
				value:[],
			}
		},
		computed: {
			...Vuex.mapState('supervisor', ['breadcrumbList', 'GetReportListArr']),
			...Vuex.mapState('breadcrumb', ['reportScreening','skinPeeler']),
			...Vuex.mapState('visualization', ['trigger']),
			echarts() {
				return 'echarts' + this.getCode();
			}
		},
		watch: {
			reportList(old, news) {
				let _this = this;
				if (this.reportList) {
					this.trigger.hospital = false;
					this.$nextTick(() => {
						_this.update();
						_this.getEcharts();
					})
				}
			},
			skinPeeler: {
			  handler(newValue, oldValue) {
				  let _this = this;
					_this.update();
					_this.getEcharts();
			  },
			  deep: true
			}			
		},
		updated() {
			let _this = this;
			if (this.trigger.hospital) {
				this.trigger.hospital = false;
				this.$nextTick(() => {
					_this.update();
					_this.getEcharts();
				})
			}
		},
		mounted() {
			//左侧导航收起时右侧图联动
			let _this = this;
			this.$nextTick(() => {
				_this.update();
				_this.getEcharts();
			})
			this.erd.listenTo(document.getElementsByClassName("el-main"), function(element) {
				if (_this.myChart) {
					let dom = document.getElementById(_this.echarts);
					if (dom) {
						dom.style.width = _this.$refs.nationwide.offsetWidth - 40 + "px";
						_this.myChart.resize();
						_this.update();
						_this.getEcharts();
					}
				}
			})
		},

		methods: {
			...Vuex.mapMutations('breadcrumb', ['setTootipType', 'clearRow']),
			...Vuex.mapMutations('supervisor', ['currentChangesSecond', 'setBreadcrumbList']),
			update(){
				let _this = this;
				_this.data = [];
				_this.value = [];
				
				if (this.reportList&&this.reportList.length > 0) {
					this.reportList.forEach(element => {
						_this.data.push({
							value: this.getCaption(element.Month),
							month: element.Month
						})
						_this.value.push({
							value: parseInt(element.MoreThan),
							month: element.Month,
							MoreThan:element.MoreThan
						})
					})
				} else {
					_this.data = [];
					_this.value = [];
				}
			},
			getCaption(obj) {
				var index = obj.lastIndexOf("\-");
				obj = obj.substring(index + 1, obj.length);
				return obj.replace(/\b(0+)/gi, "");
			},
			reportClick(item, index) {
				this.num = index;
				this.$emit(this.name, item)
			},
			getEcharts() {
				let _this = this;
				let color = [_this.colorList[0]];
				let dom = document.getElementById(_this.echarts);
				this.height = 14.5;
				this.barMaxWidth = 7;
				if (dom) {
					dom.style.width = this.$refs.breadcrumb.offsetWidth + "px";
					dom.style.height = this.$refs.breadcrumb.offsetHeight - 15 + "px";
					this.myChart = echarts.init(dom);
				}
				let changeColor = this.skinPeeler.status?'#ffffff':'#333333';
				let app = {};
				let option = null;
				option = {
					color: color,
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'none'
						},
						formatter: function(params, ticket, callback) {
							return `优于${params[0].data.MoreThan}的影像中心`;
						},
					},
					toolbox: {
						feature: {
							magicType: {
								show: true,
								type: ['bar', 'line'],
								title: {
									line: '',
									bar: '',
								},
								iconStyle: {
									borderColor: changeColor
								},
								emphasis: {
									iconStyle: {
										borderColor: _this.colorList[0]
									},
								},
							},
						},
						x:this.$refs.breadcrumb.offsetWidth-80
					},
					grid: {
						left: 20,
						right: 20,
						bottom: 0,
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: _this.data,
						triggerEvent: true,
						axisTick: {
							show: false,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#3D4049'
							}
						},
						axisLabel: {
							show: true,
							interval: 0,
							rotate:30,
							textStyle: {
								color: changeColor,
								fontSize: 12
							},
							padding:[20,0,0,0]
						},
						splitLine: {
							show: false
						}
					},
					yAxis: {
						type: 'value',
						axisTick: {
							show: false
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#3D4049'
							}
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: changeColor,
								fontSize: 12
							}
						},
						splitLine: {
							show: false
						}
					},
					series: [{
						barMaxWidth: this.barMaxWidth,
						name: '医生',
						type: _this.chartsType,
						itemStyle: {
							normal: {
								barBorderRadius: [20, 20, 20, 20],
								lineStyle:{
									width:1//设置线条粗细
								},
								label:{
									formatter: "{c}",
									  show: true,
									  position: "top",
									  textStyle: {
										fontWeight: "bolder",
										fontSize: "12",
										color: changeColor
									  }
								}
							}
						},
						data: _this.value,
						symbol: 'circle',     //设定为实心点
						symbolSize: 1,   //设定实心点的大小
						areaStyle: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
									offset: 0.5,
									color: 'RGBA('+_this.colorList[0].colorRgb()+', .6)'
								}, {
									offset: 1,
									color: 'RGBA('+_this.colorList[0].colorRgb()+', 0)'
								}],
								global: false // 缺省为 false
							}
						}
					}]
				};
				if (option && typeof option === "object"&&this.myChart) {
					this.myChart.clear()
					this.myChart.setOption(option, true);
					this.myChart.off('click'); //清除联系点击
					this.myChart.on('click', (params) => {});
					this.myChart.resize(); //区域更新
					window.addEventListener("resize", () => {
						this.myChart.resize();
					});
				}
			}
		}

	}
</script>
<style type="text/css" scoped="scoped">
	.bigScreen .barSubpageHeight{
		height: 330px;
	}
	.bigScreen .titleIcon{
		top: 16px;
		left: 20px;
	}
</style>
